import DesignConstants from "./DesignConstants";

export const ConnectColors = [
    DesignConstants.COLORS.P6_ORANGE,
    DesignConstants.COLORS.YELLOW,
    DesignConstants.COLORS.PURPLE,
    DesignConstants.COLORS.BLUE,
    DesignConstants.COLORS.DARKEST_GREY,
];

export interface ConnectWordsColor {
    name: string;
    borderColor: string;
    bgColor: string;
}

export const ConnectWordsColors: ConnectWordsColor[] = [
    { name: "orange", borderColor: "var(--color-p6-orange)", bgColor: "var(--color-connect-orange-bg)" },
    { name: "yellow", borderColor: "var(--color-p6-yellow)", bgColor: "var(--color-connect-yellow-bg)" },
    { name: "purple", borderColor: "var(--color-p6-purple)", bgColor: "var(--color-connect-purple-bg)" },
    { name: "blue", borderColor: "var(--color-connect-blue)", bgColor: "var(--color-connect-blue-bg)" },
    { name: "grey", borderColor: "var(--color-p6-grey-darkest)", bgColor: "var(--color-connect-grey-bg)" },
];
